<table *ngIf="!!ListSessions && !!ListSessions.length" class="table table-hover table-centered align-middle table-nowrap mb-0">
    <thead>
        <tr>
            <th>
                <h5 class="fs-14 my-1">Client</h5>
            </th>
            <th>
                <h5 class="fs-14 my-1">Date</h5>
            </th>
            <th>
                <h5 class="fs-14 my-1">Start Time</h5>
            </th>
            <th>
                <h5 class="fs-14 my-1">End Time</h5>
            </th>
            <th>
                <h5 class="fs-14 my-1">Duration</h5>
            </th>
            <th>
                <h5 class="fs-14 my-1">Type</h5>
            </th>
            <th>
                <h5 class="fs-14 my-1">Status</h5>
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let row of groupedRowsCache; trackBy: trackGroupedRow" (click)="onClickRow(row.item)">
            <td>
                <div class="d-flex align-items-center">
                    <div class="avatar-sm bg-light rounded p-1 me-2">
                        <img src="{{memberAvatar(row)}}" alt="" class="img-fluid d-block" />
                    </div>
                    <div>
                        <h5 class="fs-14 my-1 fw-normal">{{memberLabel(row)}}</h5>
                    </div>
                </div>
            </td>
            <td>
                <h5 class="fs-14 my-1 fw-normal">{{getStartDate(row.item.StartDate)}}</h5>
            </td>
            <td>
                <h5 class="fs-14 my-1 fw-normal">{{getStartTime(row.item.StartTime)}}</h5>
            </td>
            <td>
                <h5 class="fs-14 my-1 fw-normal">{{getEndTime(row.item.EndTime)}}</h5>
            </td>
            <td>
                <h5 class="fs-14 my-1 fw-normal">{{getDuration(row.item.Duration)}}</h5>
            </td>
            <td>
                <h5 class="fs-14 my-1 fw-normal">{{getType(row.item.Type)}}</h5>
            </td>
            <td
                class="fs-14 my-1 fw-normal"
                [ngClass]="{ 'cursor-pointer user-select-none': !isCancelled(row.item) }"
                (click)="onClickRow(row.item, $event)">
                <span class="{{statusClass(row.item.Action)}} d-inline-flex align-items-center gap-1">
                    <i *ngIf="isEditable(row.item)" class="bx bx-edit" aria-hidden="true"></i>
                    {{statusText(row.item.Action)}}
                </span>
            </td>
        </tr>
    </tbody>
  </table>
  <div *ngIf="!ListSessions || !ListSessions.length" class="text-center pt-1">No entries</div>